import { Pipe, PipeTransform } from '@angular/core';
import { MenuItem } from 'primeng/api/menuitem';
import { MonitoringAlarm } from '../models/monitoring-alarm';

@Pipe({
  name: 'filterAlarmActions'
})
export class FilterAlarmActionsPipe implements PipeTransform {

  transform(alarmActions: (MenuItem & { id: string})[], selectedAlarm: MonitoringAlarm): MenuItem[] {
    if (selectedAlarm && selectedAlarm.acknowledged) {
      alarmActions = alarmActions.filter(action => action.id !== 'acknowledge');
    }
    if (selectedAlarm && selectedAlarm.type ==='zabbix-alarm') {
      alarmActions = alarmActions.filter(action => action.id !== 'investigate-zabbix');
    }
    return alarmActions;
  }

}
